export interface ILoading {
  text: string;
}

function Loading({ text }: ILoading) {
  return (
    <div className="text-center w-100 py-5">
      <div className="w-16 h-16 border-4 border-solid border-gray-300 border-t-4 border-t-transparent rounded-full animate-spin mx-auto"></div>
      <p className="mt-3">{text}</p>
    </div>
  );
}

export default Loading;
